import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Typography, useTheme } from '@mui/material';
import { format } from 'date-fns';

interface ActivityData {
  timestamp: string;
  focus: number;
  productivity: number;
  interruptions: number;
}

interface ActivityChartProps {
  data: ActivityData[];
  height?: number;
}

const ActivityChart: React.FC<ActivityChartProps> = ({ data, height = 300 }) => {
  const theme = useTheme();

  const formattedData = data.map((item) => ({
    ...item,
    time: format(new Date(item.timestamp), 'HH:mm'),
  }));

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        Activity Overview
      </Typography>
      <ResponsiveContainer width="100%" height={height}>
        <LineChart
          data={formattedData}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
          <XAxis 
            dataKey="time" 
            stroke={theme.palette.text.secondary}
          />
          <YAxis stroke={theme.palette.text.secondary} />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}` 
            }}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="focus"
            stroke={theme.palette.primary.main}
            name="Focus Score"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="productivity"
            stroke={theme.palette.success.main}
            name="Productivity"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="interruptions"
            stroke={theme.palette.error.main}
            name="Interruptions"
            strokeWidth={1}
            strokeDasharray="5 5"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ActivityChart;